// extracted by mini-css-extract-plugin
export default {"text":"Paragraph_text__Syfz-","small":"Paragraph_small__Ono8s","medium":"Paragraph_medium__qENEE","large":"Paragraph_large__lrFCs"};